import { LS } from 'utils/localStorage';

export const getClientLS = () => LS.get('auth') || null;

export const clearClientLS = () => LS.remove('auth');
